'use client';

import { isDev } from '@/shared/utils/getStandByEnv';
import { getStrapiURL } from '@/shared/utils/utils';

export const getApiUrl = (path: string) => {
  if (isDev()) {
    return `http://localhost:1337/api${path}`;
  }
  return `${getStrapiURL()}/api${path}`;
};
